<template>
  <div class="tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" :active="key === defaultSelected">
        <!-- <b-tab title="Baseline"> -->
          <h6 class="tw-font-bolder tw-mb-0">Enrollment Success Rate</h6>
          <p class="text-secondary tw-text-xs" v-if="STUDY == 'kenya'">{{ tab.enrollments[0] }} Consented</p>
          <p class="text-secondary tw-text-xs" v-if="STUDY == 'mali'">{{ tab.enrollments[0] }} Enrolled</p>
          <doughnut-chart
            class="k-test"
            :chartdata="tab.chartdata"
            :options="tab.options"
          ></doughnut-chart>
          <div id="enrollment-label">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">
              {{ percentEnrolledAndScreened(tab.enrollments) }}%
            </h1>
            <h5 class="tw-font-bolder text-center">Successfully Enrolled</h5>
          </div>

          <div class="text-right">
            <b-button v-if="STUDY == 'kenya'" variant="danger" :id="`excluded-popover-${key}`" class="tw-mr-2">
                Excluded
            </b-button>
            <b-popover v-if="STUDY == 'kenya'"
              :target="`excluded-popover-${key}`"
              triggers="click"
              placement="top"
            >
              <template v-slot:title>Reasons for exclusions</template>

              <div
                class="d-flex justify-content-between align-items-center border-bottom tw-p-3"
              >
                HB Low
                <b-badge variant="primary" pill>{{ tab.enrollments[4] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center border-bottom tw-p-3"
              >
                Pregnancy
                <b-badge variant="primary" pill>{{ tab.enrollments[5] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center border-bottom tw-p-3"
              >
                Refused Clearance Dose
                <b-badge variant="primary" pill>{{ tab.enrollments[6] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center border-bottom tw-p-3"
              >
                Refused Pregnancy Test
                <b-badge variant="primary" pill>{{ tab.enrollments[7] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Refused Blood Sample
                <b-badge variant="primary" pill>{{ tab.enrollments[8] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Age (&lt;0.5 / &ge;10)
                <b-badge variant="primary" pill>{{ tab.enrollments[9] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Not Sleeping Within Compound
                <b-badge variant="primary" pill>{{ tab.enrollments[10] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Sleeing Outside Village
                <b-badge variant="primary" pill>{{ tab.enrollments[11] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Travel Outside Cluster
                <b-badge variant="primary" pill>{{ tab.enrollments[12] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Participation In Other Trial
                <b-badge variant="primary" pill>{{ tab.enrollments[13] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Cotrimoxazole Prophylaxis
                <b-badge variant="primary" pill>{{ tab.enrollments[14] }}</b-badge>
              </div>

              <div
                class="d-flex justify-content-between align-items-center tw-p-3"
              >
                Malaria Prophylaxis
                <b-badge variant="primary" pill>{{ tab.enrollments[15] }}</b-badge>
              </div>
            </b-popover>

            <b-button
              :to="{ name: 'metrics-subject-enrollment' }"
              variant="outline-secondary"
            >
                More
            </b-button>
          </div>
        </b-tab>
      </b-tabs>

      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>
            Enrollment Success
          </template>
          <h6>Enrolled</h6>
          <p>Consented and Screened Subjects</p>
          <h6>In Progress</h6>
          <p>Consented but not yet Screened.</p>
          <h6>Excluded</h6>
          <p>Excluded for various reasons. See "Excluded" button for details.</p>
        </info-popover>
      </div>

    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from "lodash";

export default {
  mixins: [],
  components: {
    DoughnutChart,
  },
  props: {},
  data: function () {
    return {
      ready: false,
      enrollments: [],
      defaultSelected: 'Cohort 2',
      data: {},
      chartdata: {
        datasets: [],
        labels: ["Enrolled", "In Progress", "Excluded"],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18,
          },
        },
        title: {
          display: false,
          text: "Enrolled Subjects",
        },
        tooltips: {
          bodyFontSize: 14,
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
      },
    };
  },
  computed: {
    // ...mapState('sample', ['sample'])
    
  },
  created: function () {},
  mounted: function () {
    if(this.STUDY == 'mali'){
      this.chartdata.labels = ["Enrolled", "Remaining"];
    }
    this.get();
  },
  methods: {
    get: function () {
      const that = this;
      HTTP.get("/kenya/metrics/enrollment-success")
        .then((response) => {
            _.each(response.data, (val, key) => {
                that.data[key] = {
                    id: key.replace(' ', '-'),
                    enrollments: val,
                    chartdata: _.cloneDeep(that.chartdata),
                    options: _.cloneDeep(that.options)
                };

              if(that.STUDY == 'kenya'){
                  that.data[key].chartdata.datasets.push({
                    data: [
                        val[2],
                        val[1],
                        val[3],
                    ],
                    backgroundColor: ["#37B1CA", "orange", "#EB513E"],
                });
              }
              if(that.STUDY == 'mali'){
                  that.data[key].chartdata.datasets.push({
                    data: [
                        val[0],
                        val[1]
                    ],
                    backgroundColor: ["#37B1CA", "orange"],
                });
              }                
            });
            that.ready = true;
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    percentEnrolledAndScreened: function (enrollments) {
      console.log(enrollments);
      if(this.STUDY == 'kenya'){
        var denominator = (enrollments[0]) ? enrollments[0] : 1;
        return _.round((enrollments[2] / denominator) * 100, 2);
      }
      if(this.STUDY == 'mali'){
        var denominator = 1920;
        return _.round((enrollments[0] / denominator) * 100, 2);
      }
        
    },
    find: function () {},
    create: function () {},
    patch: function () {},
    update: function () {},
    delete: function () {},
  },
};
</script>

<style scoped>
/* @import '/assets/css/doughnut-chart-label.css'; */

#enrollment-label {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}
</style>
